module.exports = __webpack_public_path__ + "res/img_play_bg.c1b0f3bca3de5d7f958242f9c0a571fa.png";